export default [
    {
        path: 'marcador-consumo-alimentar',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-marcador-consumo-alimentar' */
            '@/views/atencao-basica/marcador-consumo-alimentar/Index'
        ),
        redirect: 'marcador-consumo-alimentar/index',
        children: [
            {
                name: 'atencao-basica-marcador-consumo-alimentar-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-marcador-consumo-alimentar' */
                    '@/views/atencao-basica/marcador-consumo-alimentar/List'
                )
            },
            {
                name: 'atencao-basica-marcador-consumo-alimentar-historico-atendimento',
                path: 'historico-atendimento/:id',
                props: route => ({
                    id: parseInt(route.params.id)
                }),
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-marcador-consumo-alimentar' */
                    '@/views/atencao-basica/marcador-consumo-alimentar/Historico'
                )
            },
            {
                name: 'atencao-basica-marcador-consumo-alimentar-create',
                path: 'create/:id',
                props: route => ({
                    id: parseInt(route.params.id)
                }),
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-marcador-consumo-alimentar' */
                    '@/views/atencao-basica/marcador-consumo-alimentar/Form'
                )
            },
            {
                name: 'atencao-basica-marcador-consumo-alimentar-edit',
                path: 'edit/:id',
                props: route => ({
                    id: parseInt(route.params.id)
                }),
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-marcador-consumo-alimentar' */
                    '@/views/atencao-basica/marcador-consumo-alimentar/Form'
                )
            }
        ]
    }
];